import { arrayOf, bool, number, shape, string } from 'prop-types'

import { ReviewCustomer_v1 } from './ReviewCustomer_v1'
import { SellerReply_v1 } from './SellerReply_v1'

const Review_v1 = shape({
  activationDate: string,
  active: bool,
  categoryCodes: arrayOf(string),
  customer: shape(ReviewCustomer_v1),
  language: string,
  message: string,
  premium: bool,
  rating: number,
  reviewId: string,
  sellerReply: shape(SellerReply_v1),
  submissionDate: string,
  tenant: string,
  title: string,
  upid: string,
  variant_code: string,
  widget: bool,
})

export default Review_v1
